<template>
  <!-- POST STYLE -->
  <!-- {{getMediaById()}} -->
  <div class="postoverview"  :class="{'colstyle':isCol()}" v-if="post"
    style="background-image:url(https://images.pexels.com/photos/373543/pexels-photo-373543.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)">
  
    <div class="row">

      <div :class="{'col-sm-6 col-xs-12': !isCol(),'col-xs-12':isCol() }" >
        <!-- <div class="full_image" v-if="media"  :style="'background-image:url('+ proxyUrl + getMediaById(post.featured_media)[0].media_details.sizes.medium.source_url +')'"> -->
       <div class="full_image" v-if="media"  :style="'background-image:url('+proxyUrl+ post.jetpack_featured_media_url+')'">

        </div>
          <span class="category" v-for="category in post.categories" href="category" v-if="getCategoryById(category)">  {{getCategoryById(category) }} </span>
      </div>
      <div class=" postoverview__info" :class="{'col-sm-6':!isCol() ,'col-md-12':isCol() }">
        <h3 v-html="post.title.rendered">
        </h3>
        <div v-html="post.excerpt.rendered">
        </div>
        <div class="date_icon">
          <img src="/static/cdn/date_h577wr.svg">
          <span>
                  {{ post.date | moment("MMM DD, YYYY ") }} 
          </span>
        </div>
             <router-link :to="'/news/show/'+ post.id + '/posts' " class="readmore_btn button button--transparent-grad pulse">
                <span>
                Read more
            </span>
            </router-link>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    props: {
        post: Object,
        categories: Array,
        media:String,
        typepost:{
                  type: String,
                  default: "row"
                },
        media:Array
    },
     data() {
      return {
        proxyUrl:"" ,
        mediumImg:""      }
    },
    watch: { 
        media: {
          handler: 'mediaUpdate',
          immediate: true
        }
      },
    mounted(){
      // this.getMediaById();
      this.proxyUrl =  this.$parent.proxyUrl ;
    },
    methods:{
        getCategoryById(id){
          if(this.categories){
             var data = this.categories.filter(
            function(data){ return data.id == id });
            if(data.length>0){
              return data[0].name;
            }
          }
        },
        isCol(){
          return this.typepost=='col';
        },
        getMediaById(id){  
          if(this.media)
          {
           return this.media.filter(x=>x.id ==id);
          }
        },
        mediaUpdate(val,val2){
          // this.mediumImg = this.$parent.getMediaById(this.post.featured_media );

        }
    }
  }
</script>
<style lang="scss">
.postoverview {
  position: relative;
  margin: 43px 0;
  min-height: 251px;

  .date_icon {
    width: 100%;
  }
  &>.row {
    position: relative;
    z-index: 2;
  }

  &:after {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: black;
    content: "";
    opacity: 0.7;
    top: 0;
    left: 0;
  }

  .full_image {
    margin-top: -11px;
    max-height: 204px;
    width: calc(100% - 30px);
    margin-left: 17px;
  }

  .category {
    background-color: green;
    color: white;
    padding: 3px 15px;
    margin-top: auto;
    text-align: center;
    max-width: 93px;
    margin-left: 11px;
    position: relative;
    top: 18px;
  }
}

.postoverview.colstyle {
    margin: 9px;
}

.postoverview.colstyle .full_image {
    height: 132px;
}

.postoverview .postoverview__info  p {
    max-height: 53px;
    overflow: hidden;
    opacity: 0.9;
    padding-right: 6px;
    font-size: 14px;
}

.postoverview.colstyle .postoverview__info h3 {
    min-height: 45px;
    margin-bottom: 0;
    @media screen and (max-width:768px) {
      margin-top: 0;
    }
}
.postoverview.colstyle {
    margin-top: 31px;
}
.postoverview.colstyle .postoverview__info > p {
    margin-top: 0;
}

.postoverview.colstyle .postoverview__info {
    margin-top: 31px;
    padding-left: 21px;
}

.postoverview__info h3:before {content:"";width: 100px;height: 4px;position: absolute;background-color: #24ad60;top: 0;margin-top: -2px;}
.postoverview.colstyle .postoverview__info h3:before{
    display: none; 
}

.postoverview__info{
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/News/Parts/post.vue